/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

window.Vue = require('vue');

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i);
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default));


Vue.component('manage-licences', require('./components/ManageLicences.vue').default);
Vue.component('manage-new-articles', require('./components/ManageNewArticles.vue').default);
Vue.component('video-packet', require('./components/VideoPacket.vue').default);
Vue.component('description-sections', require('./components/DescriptionSections.vue').default);

Vue.mixin({
    methods: {
        errorHandle: error => {
            if (error.response && error.response.status == 422) {
                var message = "<ul>";
                for(var i in error.response.data.errors) {
                    message += "<li>" + error.response.data.errors[i][0] + "</li>";
                }
                message += "</ul>";
                $(".toast-header").addClass("bg-danger text-white").removeClass("bg-success");
                $(".toast-header .mr-auto").html("Bład");
                $(".toast-body").html(message);
                $(".toast").toast('show');
            };
        }
    }
});

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */
  
const app = new Vue({
    el: '#app',
});
